import * as Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import DVisualFloors from '@components/organisms/DVisualFloors.vue';

$(window).on('load', function(e) {
    const visualFloors = Vue.createApp({
        components: { DVisualFloors },
    });
    visualFloors.use(VueAxios, axios);
    visualFloors.mount('#visual-floors');
});
